<template>
    <DCard
        padding
    >
        <Form
            :errors="errors"
            @form-submitted="submitForm"
        />
    </DCard>
</template>

<script setup>
import Form from '~@/Components/Settings/LovTerminationReasons/Form.vue'
import { route } from '~@/Composables/route'

defineProps({
    errors: {
        type: Object,
        default: () => { return {} }
    }
})

function submitForm (form) {
    form.post(
        route('settings.termination-reasons.store')
    )
}
</script>

<style scoped>

</style>
